import classNames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';
import Clipboard from 'react-clipboard.js';

import SecondaryButton from '../../../../../shared/components/Button/SecondaryButton';
import Icon from '../../../../../shared/components/Icon/Icon';
import Price from '../../../../../shared/components/Price';
import ModularConfiguratorCoordinatorState from '../../ModularConfiguratorCoordinatorState';
import css from './ModularConfiguratorNavigation.css';

interface ModularConfiguratorNavigationProps {
  state: ModularConfiguratorCoordinatorState;
  className?: string;
  hidden?: boolean;
}

const ModularConfiguratorNavigation = observer(({ className, hidden, state }: ModularConfiguratorNavigationProps) => {
  const code = state.configurator.selectedComponent?.coreState.code;

  return (
    <footer className={classNames(css.container, className)} inert={hidden ? true : undefined}>
      <div className={css.summary}>
        {state.configurator.selectedComponent ? (
          <div className={css.component}>
            <div className={css.name}>{state.configurator.selectedComponent.name}</div>
            {code && (
              <div className={css.code}>
                {code}
                <Clipboard className={css.copyButton} data-clipboard-text={code}>
                  <span>
                    <Icon name="copy" />
                    <span className="visuallyHidden">Copy</span>
                  </span>
                </Clipboard>
              </div>
            )}
          </div>
        ) : (
          <span className={css.title}>{state.productFamilyName}</span>
        )}
      </div>
      <div className={css.nextStep}>
        {state.configurator?.canBePurchased && (
          <div className={css.price}>
            Total price: <Price className={css.amount} price={state.configurator.totalPrice} />
          </div>
        )}
        {state.isConfigurationInitiated ? (
          <SecondaryButton onClick={state.goToSummary}>Summary</SecondaryButton>
        ) : (
          <SecondaryButton onClick={state.setComponentMode}>
            Configure <Icon className={css.icon} name="arrowRight" />
          </SecondaryButton>
        )}
      </div>
    </footer>
  );
});

export default ModularConfiguratorNavigation;
